module.exports = __webpack_public_path__ + "img/AI_08.a93ac558.png";